import React from 'react'
import { Link } from 'react-router-dom'

const TeamSection = ({data}) => {
    return (
        <div className="container-xxl px-0 py-5">
            <div
                className="text-center mx-auto mb-5 wow fadeInUp"
                data-wow-delay="0.1s"
                style={{
                    maxWidth: 500,
                    visibility: "visible",
                    animationDelay: "0.1s",
                    animationName: "fadeInUp"
                }}
            >
                <p className="text-primary text-uppercase mb-2">Our Team</p>
                <h1 className="display-6 mb-0">Creative Photograher And Videographer</h1>
            </div>
            <div className="row g-0">
                <div
                    className="col-lg-6 wow fadeIn"
                    data-wow-delay="0.1s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.1s",
                        animationName: "fadeIn"
                    }}
                >
                    <div className="row g-0 flex-sm-row">
                        <div className="col-sm-6">
                            <div className="team-img position-relative">
                                <img className="img-fluid" src="../assets/img/team-1.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="h-100 p-5 d-flex flex-column justify-content-between">
                                <div className="mb-3">
                                    <h4>Lucifer Jhones</h4>
                                    <span>Photographer</span>
                                </div>
                                <p>
                                    Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed
                                    stet lorem sit clita duo
                                </p>
                                <div className="d-flex">
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-twitter" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-6 wow fadeIn"
                    data-wow-delay="0.3s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.3s",
                        animationName: "fadeIn"
                    }}
                >
                    <div className="row g-0 flex-sm-row-reverse flex-lg-row">
                        <div className="col-sm-6">
                            <div className="team-img position-relative">
                                <img className="img-fluid" src="../assets/img/team-2.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="h-100 p-5 d-flex flex-column justify-content-between">
                                <div className="mb-3">
                                    <h4>Jesse Joslin</h4>
                                    <span>Videographer</span>
                                </div>
                                <p>
                                    Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed
                                    stet lorem sit clita duo
                                </p>
                                <div className="d-flex">
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-twitter" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-6 wow fadeIn"
                    data-wow-delay="0.1s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.1s",
                        animationName: "fadeIn"
                    }}
                >
                    <div className="row g-0 flex-lg-row-reverse">
                        <div className="col-sm-6">
                            <div className="team-img position-relative">
                                <img className="img-fluid" src="../assets/img/team-3.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="h-100 p-5 d-flex flex-column justify-content-between">
                                <div className="mb-3">
                                    <h4>Richard Archer</h4>
                                    <span>Retoucher</span>
                                </div>
                                <p>
                                    Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed
                                    stet lorem sit clita duo
                                </p>
                                <div className="d-flex">
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-twitter" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="col-lg-6 wow fadeIn"
                    data-wow-delay="0.3s"
                    style={{
                        visibility: "visible",
                        animationDelay: "0.3s",
                        animationName: "fadeIn"
                    }}
                >
                    <div className="row g-0 flex-sm-row-reverse">
                        <div className="col-sm-6">
                            <div className="team-img position-relative">
                                <img className="img-fluid" src="../assets/img/team-4.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="h-100 p-5 d-flex flex-column justify-content-between">
                                <div className="mb-3">
                                    <h4>April Ryan</h4>
                                    <span>Editor</span>
                                </div>
                                <p>
                                    Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed
                                    stet lorem sit clita duo
                                </p>
                                <div className="d-flex">
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-twitter" />
                                    </Link>
                                    <Link
                                        className="btn btn-square btn-outline-primary rounded-circle me-2"
                                        to=""
                                    >
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default TeamSection
